export default "__VITE_ASSET__FGQ1bL6e__"